module.exports = __webpack_public_path__ + "static/media/star.6dad83f3.svg";